/* All homepage narrative content — shared by the cinematic and static/reduced variants. */

export const CATEGORIES_UI = [
  { name: "Wine", slug: "wine", origins: "France · Chile · Luxembourg · Ukraine · Italy · Austria" },
  { name: "Beer", slug: "beer", origins: "Belgium · Germany · Netherlands" },
  { name: "Gin", slug: "gin", origins: "Belgium · Spain" },
  { name: "Tequila", slug: "tequila", origins: "Mexico" },
  { name: "Scotch", slug: "scotch", origins: "Scotland" },
  { name: "Vodka", slug: "vodka", origins: "Campari — Skyy" },
  { name: "Liqueur", slug: "liqueur", origins: "Italy" },
];

export const ORIGINS = [
  "Scotland", "Netherlands", "Belgium", "Luxembourg", "Germany", "France",
  "Austria", "Spain", "Italy", "Ukraine", "Mexico", "Chile",
];

export const CHANNELS = [
  "Hospitality", "Retail", "Diplomatic", "Institutional",
  "Modern Trade", "Airports & Airlines", "Clubs", "Wholesale",
];

export const CH7_STATS = [
  { value: "10,000 SQ. FT.", label: "Private custom-bonded warehouse" },
  { value: "15,000+ SQ. FT.", label: "Additional warehousing capacity" },
  { value: "DELHI NCR", label: "Company-owned fleet and permanent logistics team" },
  { value: "10,000+", label: "Trade and institutional client touchpoints" },
];

export const MAP_STATES = [
  "Maharashtra", "Goa", "Chandigarh", "Punjab", "Himachal Pradesh", "Haryana",
  "Uttar Pradesh", "Andhra Pradesh", "Karnataka", "Tamil Nadu", "Madhya Pradesh", "Delhi NCR",
];

export const HOME_CHAPTERS = [
  {
    id: 1,
    label: "IMPORTS · DISTRIBUTION · MARKET ACCESS",
    headline: "CURATING GLOBAL TASTE FOR INDIA.",
    body: "Since 2001, Hema Connoisseur Collections has connected distinguished breweries, wineries and spirit houses with India's hospitality, retail, diplomatic and institutional markets.",
    ctas: [
      { label: "Explore Our Portfolio", to: "/portfolio", testId: "cta-explore-portfolio" },
      { label: "Partner With HCC", to: "/partner", testId: "cta-partner-hcc" },
    ],
  },
  {
    id: 2,
    headline: "Selection is only the beginning.",
    body: "HCC combines portfolio curation with market intelligence, regulatory understanding, distribution infrastructure and relationships built over more than two decades.",
    phrase: "We do not simply move products. We build market presence.",
  },
  {
    id: 3,
    headline: "A world of distinguished beverages.",
    custom: "categories",
  },
  {
    id: 4,
    headline: "Global houses. Indian markets.",
    body: "Our portfolio brings together respected breweries, wineries and spirit producers from across the world, selected for quality, character and market relevance.",
  },
  {
    id: 5,
    headline: "Built for India's complex beverage landscape.",
    body: "Every region, trade channel and regulatory environment requires a different approach. HCC combines national ambition with local market understanding.",
    ctas: [{ label: "View Distribution Network", to: "/distribution", testId: "cta-distribution" }],
  },
  {
    id: 6,
    headline: "Present across the channels that shape preference.",
    custom: "channels",
  },
  {
    id: 7,
    headline: "Premium portfolios need disciplined movement.",
    body: "From customs-bonded storage to structured last-mile supply, HCC supports beverage brands with infrastructure built for control, consistency and dependable execution.",
    custom: "stats",
  },
  {
    id: 8,
    headline: "More than distribution. A route to market.",
    body: "For global beverage houses entering India—and for Indian trade partners seeking reliable supply—HCC offers access, infrastructure, relationships and market intelligence developed since 2001.",
    ctas: [
      { label: "Introduce Your Brand", to: "/partner", testId: "cta-introduce-brand" },
      { label: "Send a Trade Enquiry", to: "/contact", testId: "cta-trade-enquiry" },
    ],
  },
];

export const CH9 = {
  eyebrow: "ADDITIONAL CAPABILITIES",
  headline: "Beyond the alcoholic portfolio.",
  body: "HCC also supports selected non-alcoholic beverage and FMCG distribution across Delhi NCR, including mixers, juices, energy drinks, mineral water and related categories.",
  cta: { label: "View Additional Categories", to: "/non-alcoholic-fmcg", testId: "cta-non-alco" },
};

export const END_FRAME = {
  headline: "Let us build the next market together.",
  ctas: [
    { label: "Partner With HCC", to: "/partner", testId: "endframe-partner" },
    { label: "Discuss Distribution", to: "/distribution", testId: "endframe-distribution" },
    { label: "Contact Our Team", to: "/contact", testId: "endframe-contact" },
  ],
};
